import React, { useState, useRef, useEffect } from "react";
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { useNavigate } from 'react-router-dom';
import { useForm  } from "react-hook-form";
import { ErrorMessage } from '@hookform/error-message';
import emailjs from '@emailjs/browser';
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import swal from 'sweetalert'

const ContactoForm = () => {

    const { t } = useTranslation();
    const location = useLocation();
    const isEnglish = location.pathname.startsWith("/en");

    const form = useRef();
    const navigate = useNavigate();

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();

    const [contact, setContact] = useState({
    date: new Date().toLocaleDateString('es-AR'),
    origen: window.location.pathname,
    nombre: "",
    apellido: "",
    email: "",
    telefono: "",
    mensaje: "",
    });

    useEffect(() => {
    Object.keys(contact).forEach((key) => {
        setValue(key, contact[key]);
    });
    }, [contact, setValue]);

    const sendEmail = () => {
    emailjs.sendForm('gmail', 'mail-contacto', form.current, 'cVs-USqvn4kU6rYPL')
        .then((result) => {
        console.log(result.text);
        })
        .catch((error) => {
        console.log(error.text);
        });
    };

    const createContact = () => {
        addDoc(collection(db, "contact"), { contact })
            .then(() => {
                swal("¡GRACIAS POR CONTACTARTE!", "En breve te estaremos respondiendo", "success");
                sendEmail();
                navigate("/");
            })
            .catch((error) => {
                console.log(error);
                swal("¡Ups!", "Algo falló", "error");
            });
    };
    
    return(
        <section id="contacto">
            <div className="contacto">
                <div className="container-form">
                    <form ref={form} onSubmit={handleSubmit(createContact)}>
                        <input 
                            type="text" 
                            name="nombre" 
                            placeholder={t("contacto.nombre")}
                            value={contact.nombre}
                            {...register("nombre", { required: `${t("contacto.requerido")}` })}
                            onChange={(e) => setContact({...contact, nombre: e.target.value})}
                        />
                        <ErrorMessage
                            errors={errors}
                            name="nombre"
                            render={({ message }) => <p>{message}</p>}
                        />

                        <input 
                            type="text" 
                            name="apellido" 
                            placeholder={t("contacto.apellido")}
                            value={contact.apellido}
                            {...register('apellido', { required: `${t("contacto.requerido")}` })}
                            onChange={(e) => setContact({...contact, apellido: e.target.value})}
                        />
                        <ErrorMessage
                            errors={errors}
                            name="apellido"
                            render={({ message }) => <p>{message}</p>}
                        />

                        <input 
                            type="email" 
                            name="email" 
                            placeholder="EMAIL" 
                            value={contact.email}
                            {...register('email', { required: `${t("contacto.requerido")}` })}
                            onChange={(e) => setContact({...contact, email: e.target.value})}
                        />
                        <ErrorMessage
                            errors={errors}
                            name="email"
                            render={({ message }) => <p>{message}</p>}
                        />

                        <input 
                            type="number" 
                            name="telefono" 
                            placeholder={t("contacto.telefono")}
                            pattern="[0-9]+" 
                            value={contact.telefono}
                            {...register('telefono', { required: `${t("contacto.requerido")}` })}
                            onChange={(e) => setContact({...contact, telefono: e.target.value})}
                        />
                        <ErrorMessage
                            errors={errors}
                            name="telefono"
                            render={({ message }) => <p>{message}</p>}
                        />

                        <textarea 
                            type="text" 
                            name="mensaje" 
                            rows="6" 
                            placeholder={t("contacto.mensaje")}
                            value={contact.message}
                            {...register('mensaje')}
                            onChange={(e) => setContact({...contact, mensaje: e.target.value})}
                        />
                        
                        { !contact
                            ? ""
                            : <input type="submit" value={t("contacto.enviar")} className="btn" onClick={()=> {}}/>
                        }
                    </form>
                </div>
                <div className="container-map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2905.813393006568!2d-65.3189523085893!3d-43.25533258971083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xbe0144c0ad3b1ec1%3A0xfbe3b5f17eaf265a!2sYASKIA%20S.A.!5e0!3m2!1ses-419!2sar!4v1757518434408!5m2!1ses-419!2sar" loading="lazy" ></iframe>
                </div>
            </div>
        </section>
    )
}

export default ContactoForm